import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import ResponsiveImage from '../layout/images/responsive';
import styles from './tiles.scss';

class Tiles extends Component {
  render() {
    const { tiles } = this.props;

    const tileElements = tiles.map((tile) => {
      return (
        <NavLink key={tile.sys.id} className={styles.tile} to={'/' + tile.fields.slug}>
          <div className={styles.title}>
            <h3>{tile.fields.title}</h3>
          </div>
          <div className={styles.visual}>
            <ResponsiveImage image={tile.fields.sharingImage} ratio={65} showCaption={false}/>
          </div>
        </NavLink>
      );
    });

    return (
      <section className={styles.tiles}>
        {tileElements}
      </section>
    );
  }
}

Tiles.propTypes = {
  tiles: PropTypes.array.isRequired
}

export default Tiles;



// WEBPACK FOOTER //
// ./src/components/tiles/tiles.jsx